<template>
	<svg
        xmlns="http://www.w3.org/2000/svg"
        width="1.5rem"
        height="1.5rem"
        viewBox="0 0 128 128"
        style="margin-top: 4px"
    >
		<path fill="currentColor" d="M108.6 46.9c-2.3-.2-6.7 1-8.7 10.8c0 5.9 1.4 9.5 3.6 10.8c4.1 1.2 8.9-4.3 8.9-10.2c.2-4.1.4-9.2-3.8-11.4" />
		<path fill="currentColor" d="M116.3 25.8H11.7C5.2 25.8 0 31 0 37.4v40c0 6.4 5.2 11.7 11.7 11.7h104.7c6.4 0 11.7-5.2 11.7-11.7v-40c-.1-6.4-5.3-11.6-11.8-11.6M44 80s-6.9-9.1-8.5-16c-1.6-6.8-2-3.7-2-3.7S28 72.7 22.3 80.6s-8.5-3.9-8.5-3.9c-2-2.4-7.7-37.3-7.7-37.3c3.2-8.9 8.7-1.6 8.7-1.6l5.5 28.4s8.5-17.4 11.4-21.9c2.8-4.5 7.7-3.2 8.1 1.4c.4 4.7 5.1 17.4 5.1 17.4c.4-13.4 5.9-26.2 6.7-28.2s9.7-4.5 8.1 4.1C55.8 48.5 52 68.6 53 79.6c-2.7 8.3-9 .4-9 .4m35.9-4.5c-2.6 1.2-12.3 7.9-19.2-7.1C56.4 53.3 66 42.2 66 42.2s12.5-10.7 21 3.5c6.9 15.6-4.5 28.6-7.1 29.8m31.8 0c-2.6 1.2-12.3 7.9-19.2-7.1c-4.3-15.1 5.3-26.2 5.3-26.2s12.6-10.8 21.1 3.4c6.9 15.7-4.6 28.7-7.2 29.9" />
		<path fill="currentColor" d="M76.7 46.9c-2.3-.2-6.7 1-8.7 10.8c0 5.9 1.4 9.5 3.6 10.8c4.1 1.2 8.9-4.3 8.9-10.2c.3-4.1.5-9.2-3.8-11.4M61.3 89.1l22.3 13.1l-4.7-13.1l-12.8-3.6z" />
	</svg>
</template>

<script>
export default {
	name: 'IconWoocommerce'
};
</script>
